export {
    dateProps,
    getDateRange
}

let rangePickerOptions = {
    disabledDate,
    shortcuts: [
        {
            text: '昨天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '最近7天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '最近14天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 13);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        },
        {
            text: '最近30天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 29);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: '最近90天',
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 89);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        }
    ]
}

function disabledDate(date) {
    const cur = new Date();
    cur.setHours(0);
    cur.setMinutes(0);
    cur.setSeconds(0);
    cur.setMilliseconds(0);
    return date >= cur
}

function getDateRange(startOffset = -8, endOffset = -1) {
    const today = new Date()
    const start = new Date(today)
    start.setDate(today.getDate() + startOffset)
    const end = new Date(today)
    end.setDate(today.getDate() + endOffset)
    return [start.toISOString().split('T')[0], end.toISOString().split('T')[0]]
}

let dateProps = {
    'value-format': 'yyyy-MM-dd',
    'type': 'daterange',
    'picker-options': rangePickerOptions,
    'range-separator': '至',
    'start-placeholder': '开始日期',
    'end-placeholder': '结束日期'
}
